import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ExpiredConversationLinkPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f4f7fb",
        textAlign: "center",
        padding: "20px",
        fontFamily: "Arial, Helvetica, sans-serif",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          padding: "40px 50px",
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          maxWidth: "500px",
          width: "100%",
        }}
      >
        <div
          style={{
            fontSize: "52px",
            marginBottom: "18px",
          }}
        >
          ⏳
        </div>

        <h1
          style={{
            fontSize: "32px",
            color: "#1f2937",
            marginBottom: "12px",
          }}
        >
          Link Expired
        </h1>

        <p
          style={{
            fontSize: "16px",
            color: "#6b7280",
            lineHeight: "1.5",
          }}
        >
          This link has expired. Please try requesting it again.
        </p>

        <Button
          style={{
            marginTop: "20px",
            backgroundColor: "#2563eb",
            color: "#ffffff",
            padding: "10px 20px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "600",
            textTransform: "none",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
          onClick={() => navigate("/")}
        >
          Return to Home Page
        </Button>
      </div>
    </div>
  );
};

export default ExpiredConversationLinkPage;
